//文字コードはutf-8

// Swiper は lib/swiper-bundle.min.js（グローバル window.Swiper）を使用

/* 事業相関スライダー（Swiper・SP専用）
 * - PCでは相関図を1枚画像で表示するため、スライダーはSP幅でのみ初期化する
 * - 矢印 / ドットで移動、中央寄せ・ループ
 * - 自動再生（モーション低減環境では停止）
 * - 既存の BEM クラスをそのまま Swiper の各パーツに割り当てる
 *   （swiper- 系のケバブクラスをマークアップに足さない → BEMチェックを汚さない）
========================================================*/
export function initBusinessMap() {
    const root = document.querySelector('.jsBusinessMap');
    if (!root || !window.Swiper) return;

    const section = root.closest('.serviceMap') || document;
    const prevBtn = section.querySelector('[data-slider="prev"]');
    const nextBtn = section.querySelector('[data-slider="next"]');
    const dotsWrap = section.querySelector('.serviceMap__dots');
    const AUTOPLAY_MS = 4500;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const spQuery = window.matchMedia('(max-width: 768px)');

    let swiper = null;

    const build = () => {
        if (swiper) return;
        swiper = new window.Swiper(root, {
            // 既存 BEM クラスを Swiper のラッパー / スライドとして使う
            wrapperClass: 'serviceMap__track',
            slideClass: 'serviceMap__slide',
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 24,
            loop: true,
            initialSlide: 0, // 先頭「瓦事業（野村屋の原点）」を中央に（ドットも1番目が有効）
            speed: reduceMotion ? 0 : 500,
            autoplay: {
                delay: AUTOPLAY_MS,
                disableOnInteraction: false,
            },
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
            pagination: dotsWrap ? {
                el: dotsWrap,
                clickable: true,
                bulletClass: 'serviceMap__dot',
                bulletActiveClass: 'serviceMap__dot--active',
                renderBullet: (index, className) =>
                    `<button type="button" class="${className}" aria-label="${index + 1}番目の事業を表示"></button>`,
            } : false,
        });

        // モーション低減環境では自動再生しない
        if (reduceMotion) swiper.autoplay.stop();
    };

    const destroy = () => {
        if (!swiper) return;
        swiper.destroy(true, true);
        swiper = null;
    };

    const apply = () => {
        spQuery.matches ? build() : destroy();
    };

    apply();
    spQuery.addEventListener('change', apply);
}
